export const ACC_API_URL = process.env.REACT_APP_ACC_API_URL;
export const ACC_API_KEY = process.env.REACT_APP_ACC_API_KEY;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// Base URL only: the agent admin API authenticates the caller's own Google identity, so
// there is no agent key to configure here (see AgentMonitoringUtils).
export const AGENT_API_BASE = process.env.REACT_APP_AGENT_API_BASE;

export const GYMS = {
    "Meridian, Idaho": "2",
    "San Francisco, California": "3",
};

// The GymMaster staff console for our club. Verified live; also linked from Helpful Links.
export const GYMMASTER_DASHBOARD_URL = 'https://blackboxvr.gymmasteronline.com/dashboard';

// Deep link to one member's page in the staff console, with {id} standing in for the numeric
// gymMasterMemberId. Taken from the real address bar (Raiden, 2026-09-01) - GymMaster does
// not document this route, and every guessed shape 404s while this one 302s to login like
// the console itself. If it ever stops working, set it back to null: the UI then falls back
// to a copyable id plus a console link, which cannot open the wrong member's page.
export const GYMMASTER_MEMBER_URL_PATTERN = 'https://blackboxvr.gymmasteronline.com/member/view/{id}';
